import { put, select } from 'redux-saga/effects';
///internal
import * as ActionType from '@app/store/typings/actions/account.d';
import * as authenticationService from '@app/services/authentication';
import {
  CreateUser,
  ValidatePhoneOtpUpdateProfile,
  ValidateEmailOtpUpdateProfile,
} from '../../typings/actions/account';
import { handleError } from '@app/utils/service';
import {
  getLineIdRegister,
  getLineRegisterPathRedirect,
  removeLineIdRegister,
  removeLineRegisterPathRedirect,
  setInviteToken,
} from '@app/utils/localStorage';
import { UserType } from '@app/store/typings/actions/user';
import { RootState } from '@app/store/typings/state/root';
import swal from 'sweetalert2';
import notification from 'antd/lib/notification';

export function* emailHandle({ payload }: ActionType.EmailCheck) {
  try {
    const { status } = yield authenticationService.emailAvailability(payload.email);
    if (status === 200) {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_EMAIL_AVAILABILITY_SUCCESS',
      });
    }
  } catch (error: any) {
    const errorCode = error.response.status;
    if (errorCode === 400) {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_EMAIL_AVAILABILITY_FAILED',
        payload: {
          message: 'accounts.register.email_invalid',
        },
      });
    }
    if (errorCode === 404) {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_EMAIL_AVAILABILITY_FAILED',
        payload: {
          message: 'accounts.register.email_required',
        },
      });
    }
    if (errorCode === 409) {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_EMAIL_AVAILABILITY_FAILED',
        payload: {
          message: 'accounts.register.email_already exist',
        },
      });
    }
  }
}

export function* updateUserPhone(payload: ValidatePhoneOtpUpdateProfile) {
  try {
    const { data } = yield authenticationService.updateUser(
      payload.payload.otp,
      payload.payload.phoneSessionId,
    );
    if (data.code === 'KS000') {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_CREATE_SUCCESS',
      });
      yield put<UserType>({ type: 'KEY_USER_MYUSER_FETCH' });
      notification.success({
        message: 'Success',
        description: `update successful`,
      });
    }
  } catch (error) {
    yield put<ActionType.AccountType>({
      type: 'KEY_ACCOUNT_CREATE_FAILED',
    });
    alert('Error! Please try again later');
  }
}

export function* updateUserEmail(payload: ValidateEmailOtpUpdateProfile) {
  try {
    const { data } = yield authenticationService.updateUser(
      payload.payload.otp,
      payload.payload.emailSessionId,
      payload.payload.userId,
    );
    if (data.code === 'KS000') {
      if (payload.payload.userId) {
        yield put<UserType>({ type: 'KEY_USER_INPROJECT_WITHID', payload: payload.payload.userId });
        notification.success({
          message: 'Success',
          description: `update email successful`,
        });
      } else {
        yield put<ActionType.AccountType>({
          type: 'KEY_ACCOUNT_CREATE_SUCCESS',
        });
        yield put<UserType>({ type: 'KEY_USER_MYUSER_FETCH' });
        notification.success({
          message: 'Success',
          description: `update successful`,
        });
      }
    }
  } catch (error) {
    yield put<ActionType.AccountType>({
      type: 'KEY_ACCOUNT_CREATE_FAILED',
    });
    alert('Error! Please try again later');
  }
}

export function* phoneHandle({ payload }: ActionType.PhoneCheck) {
  try {
    const { status } = yield authenticationService.phoneAvailability(payload.phoneNumber);
    if (status === 200) {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_PHONE_AVAILABILITY_SUCCESS',
      });
    }
  } catch (error: any) {
    const errorCode = error.response.status;
    if (errorCode === 400) {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_PHONE_AVAILABILITY_FAILED',
        payload: {
          message: 'accounts.register.phone_invalid',
        },
      });
    }
    if (errorCode === 500) {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_PHONE_AVAILABILITY_FAILED',
        payload: {
          message: 'accounts.register.phone_invalid',
        },
      });
    }
    if (errorCode === 404) {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_PHONE_AVAILABILITY_FAILED',
        payload: {
          message: 'Please enter your phone number',
        },
      });
    }
    if (errorCode === 409) {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_PHONE_AVAILABILITY_FAILED',
        payload: {
          message: 'accounts.register.phone_already exist',
        },
      });
    }
  }
}

export function* generateOTP({ payload }: ActionType.GenOtp) {
  try {
    const { data } = yield authenticationService.generateOTP(
      payload.type,
      payload.email,
      payload.phoneNumber,
    );
    if (data.code === 'KS000' && payload.type === 'email') {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_SET_EMAIL_SESSION',
        payload: {
          emailRef: data.data.ref,
          emailSessionId: data.data.sessionId,
        },
      });
    }
    if (data.code === 'KS004') {
      swal.fire({
        icon: 'error',
        title: 'กรุณาลองอีกครั้งหลัง 1 นาที',
        confirmButtonColor: '#8CD4F5',
      });
    }
    if (data.code === 'KS000' && payload.type === 'sms') {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_SET_PHONE_SESSION',
        payload: {
          phoneRef: data.data.ref,
          phoneSessionId: data.data.sessionId,
        },
      });
    }
  } catch (error) {
    swal.fire({
      icon: 'error',
      title: 'กรุณาลองอีกครั้งหลัง 1 นาที',
      confirmButtonColor: '#8CD4F5',
    });
    handleError(error);
  }
}

export function* validateEmailOTP({ payload }: ActionType.ValidateEmailOtp) {
  try {
    const { data } = yield authenticationService.validateOTP(payload.emailSessionId!, payload.otp);
    if (data.code === 'KS000') {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_VALIDATE_EMAIL_OTP_SUCCESS',
      });
      yield createUser({
        email: payload.email,
        password: payload.password,
        firstName: payload.firstName,
        lastName: payload.lastName,
        emailSessionId: payload.emailSessionId,
        username: payload.username,
      });
    }
  } catch (error) {
    yield put<ActionType.AccountType>({
      type: 'KEY_ACCOUNT_VALIDATE_EMAIL_OTP_FAILED',
    });
  }
}

export function* validatePhoneOTP({ payload }: ActionType.ValidatePhoneOtp) {
  try {
    const { data } = yield authenticationService.validateOTP(payload.sessionId, payload.otp);
    if (data.code === 'KS000') {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_VALIDATE_PHONE_OTP_SUCCESS',
      });
      yield createUser({
        phone: payload.phone,
        password: payload.password,
        firstName: payload.firstName,
        lastName: payload.lastName,
        phoneSessionId: payload.sessionId,
        username: payload.username,
      });
    }
  } catch (error) {
    yield put<ActionType.AccountType>({
      type: 'KEY_ACCOUNT_VALIDATE_PHONE_OTP_FAILED',
    });
  }
}

function* createUser(payload: CreateUser) {
  try {
    const { data } = yield authenticationService.createUser(
      payload.email,
      payload.password,
      payload.phone,
      payload.firstName,
      payload.lastName,
      payload.emailSessionId,
      payload.phoneSessionId,
      payload.username,
    );
    if (data.code === 'KS000') {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_CREATE_SUCCESS',
      });
      console.log(payload);
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_LOGIN_FETCH',
        payload: {
          email: payload.email,
          phone: payload.phone,
          password: payload.password!,
        },
      });
      if (getLineIdRegister()) {
        removeLineIdRegister();
      }
      const pathToLine = getLineRegisterPathRedirect();
      if (pathToLine) {
        removeLineRegisterPathRedirect();
        // eslint-disable-next-line no-restricted-globals
        location.assign(pathToLine);
      }
    }
  } catch (error: any) {
    const data = error.response.data;
    swal.fire({ icon: 'error', title: data.message, confirmButtonColor: '#8CD4F5' });
    handleError(error);
  }
  yield put<ActionType.AccountType>({
    type: 'KEY_ACCOUNT_CREATE_FAILED',
  });
}

export function* validateInviteEmail({ payload }: ActionType.ValidateInviteEmail) {
  try {
    const { data, status } = yield authenticationService.validateInviteEmail(payload);
    if (status === 201) {
      setInviteToken(data.access_token);
      yield put<UserType>({ type: 'KEY_USER_INVITE_FETCH' });
    }
  } catch (error: any) {
    if (error?.response?.data?.code === 'KS070') {
      yield put<ActionType.AccountType>({
        type: 'KEY_INVITEE_REGISTERED',
      });
    }
    handleError(error);
  }
}

export function* generateInviteOTP() {
  try {
    const phonenumber: string = yield select(
      (state: RootState) => state.account.dataForm.phoneNumber,
    );
    const { data } = yield authenticationService.generateInviteOTP(phonenumber);
    if (data.success) {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_SET_PHONE_SESSION',
        payload: {
          phoneRef: data.data.ref,
          phoneSessionId: data.data.sessionId,
        },
      });
    }
  } catch (error: any) {
    handleError(error);
  }
}

export function* validateInvitePhone({ payload }: ActionType.ValidateInvitePhone) {
  try {
    const phoneSessionId: string = yield select(
      (state: RootState) => state.account.dataForm.phoneSessionId,
    );
    const { status } = yield authenticationService.validateInvitePhone(phoneSessionId, payload);
    if (status === 201) {
      yield put<UserType>({ type: 'KEY_USER_UPDATE_INVITE' });
    }
  } catch (error: any) {
    yield put<ActionType.AccountType>({
      type: 'KEY_ACCOUNT_VALIDATE_PHONE_OTP_FAILED',
    });
    handleError(error);
  }
}
